module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/register-keyvisual_ja_sp-a04a19ef2483404c8a828e2c890d62d8.png";